import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Header from '../components/Header';
import { Card } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { User, ShoppingCart, Package, LogOut, Shield, FolderOpen } from 'lucide-react';
import MyOrders from '../components/MyOrders';
import MyCart from '../components/MyCart';
import MyProfile from '../components/MyProfile';
import MySecurity from '../components/MySecurity';
import MyProjects from '../components/MyProjects';

const MyAccount = () => {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const [activeTab, setActiveTab] = useState('projects'); // projects, orders, cart, profile, security

  React.useEffect(() => {
    if (!user) {
      navigate('/');
    }
  }, [user, navigate]);

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  if (!user) {
    return null;
  }

  const menuItems = [
    { id: 'projects', label: 'Meus Projetos', icon: FolderOpen },
    { id: 'orders', label: 'Meus Pedidos', icon: Package },
    { id: 'cart', label: 'Meu Carrinho', icon: ShoppingCart },
    { id: 'profile', label: 'Meus Dados', icon: User },
    { id: 'security', label: 'Segurança', icon: Shield },
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-3xl font-bold text-gray-800 mb-8">
          Olá, {user.name}!
        </h1>

        <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
          {/* Sidebar */}
          <div className="lg:col-span-1">
            <Card className="p-4">
              <nav className="space-y-2">
                {menuItems.map((item) => {
                  const Icon = item.icon;
                  return (
                    <button
                      key={item.id}
                      onClick={() => setActiveTab(item.id)}
                      className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg transition-colors ${
                        activeTab === item.id
                          ? 'bg-[#00A86B] text-white'
                          : 'text-gray-700 hover:bg-gray-100'
                      }`}
                    >
                      <Icon size={20} />
                      <span className="font-medium">{item.label}</span>
                    </button>
                  );
                })}
                
                <button
                  onClick={handleLogout}
                  className="w-full flex items-center gap-3 px-4 py-3 rounded-lg text-red-600 hover:bg-red-50 transition-colors mt-4"
                >
                  <LogOut size={20} />
                  <span className="font-medium">Sair</span>
                </button>
              </nav>
            </Card>
          </div>

          {/* Content */}
          <div className="lg:col-span-3">
            {activeTab === 'projects' && <MyProjects />}
            {activeTab === 'orders' && <MyOrders />}
            {activeTab === 'cart' && <MyCart />}
            {activeTab === 'profile' && <MyProfile />}
            {activeTab === 'security' && <MySecurity />}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyAccount;
